<template>
  <div>
    <heading>{{ $t("proof.category.title") }}</heading>
    <proofMonthStrip />
    <proofCategoryTable />
  </div>
</template>

<script>
import proofCategoryTable from "./proofCategoryTable.vue";
import proofMonthStrip from "./proofMonthStrip.vue";
export default {
  name: "proofCategory",
  components: { proofCategoryTable, proofMonthStrip },
};
</script>
